/*
 * UAT footer: keep Shopify Email and Shopify Forms SMS fields level on desktop/tablet.
 * Only moves the rendered signup blocks; Shopify owns both submissions and SMS consent.
 */
(() => {
  'use strict';
  const originals = new WeakMap();
  let footerObserver;
  let shadowObserver;
  let watchedShadow;
  let queued = false;
  let lastEmail;
  let lastSms;

  const remember = node => {
    if (node && !originals.has(node)) originals.set(node, node.style.marginTop);
  };
  const restore = node => {
    if (node && originals.has(node)) node.style.marginTop = originals.get(node);
  };
  const findContent = group => group && group.querySelector(':scope > .group-block-content');
  const groupContent = node => findContent(node && node.closest('.group-block'));

  function sync() {
    const footer = document.querySelector('.footer-content');
    if (!footer) return;
    const emailField = footer.querySelector('.email-signup__input-group');
    const emailBox = emailField && (emailField.closest('.shopify-block') || emailField.closest('.email-signup-block'));
    const host = footer.querySelector('form-embed, shopify-forms-embed');
    const smsBox = host && (host.closest('.shopify-app-block') || host.closest('.shopify-block') || host);
    const shadow = host && host.shadowRoot;

    remember(emailBox);
    remember(smsBox);
    if (window.innerWidth < 750) {
      restore(emailBox || lastEmail);
      restore(smsBox || lastSms);
      return;
    }
    if (!emailField || !emailBox || !smsBox || !shadow) return;
    if (shadow !== watchedShadow) {
      if (shadowObserver) shadowObserver.disconnect();
      watchedShadow = shadow;
      shadowObserver = new MutationObserver(schedule);
      shadowObserver.observe(shadow,{childList:true,subtree:true});
    }
    const phone = shadow.querySelector('[data-uat-phone-row]') ||
      shadow.querySelector('input[data-uat-phone-fallback]') ||
      shadow.querySelector('input[type="tel"]');
    if (!phone) return;

    // Start from the native layout, not yesterday's offset.
    restore(emailBox);
    restore(smsBox);
    const emailY = emailField.getBoundingClientRect();
    const phoneY = phone.getBoundingClientRect();
    if (!emailY.width || !phoneY.width || !emailY.height || !phoneY.height) return;
    const emailContent = groupContent(emailBox);
    const smsContent = groupContent(smsBox);
    const emailDesc = emailContent && emailContent.children[1];
    const smsDesc = smsContent && smsContent.children[1];
    const emailDescEnd = emailDesc ? emailDesc.getBoundingClientRect().bottom : emailY.top-12;
    const smsDescEnd = smsDesc ? smsDesc.getBoundingClientRect().bottom : phoneY.top-12;
    // Same baseline, with breathing room below either description even on narrow tablets.
    const target = Math.max(emailY.top, emailDescEnd+12, smsDescEnd+12);
    const emailOffset = Math.round(target-emailY.top);
    const smsOffset = Math.round(target-phoneY.top);
    // Keep the correction bounded if Shopify temporarily renders a placeholder.
    if (emailOffset>=0 && emailOffset<=100) emailBox.style.marginTop = 'calc('+(parseFloat(getComputedStyle(emailBox).marginTop)||0)+'px + '+emailOffset+'px)';
    if (Math.abs(smsOffset)<=110) smsBox.style.marginTop = 'calc('+(parseFloat(getComputedStyle(smsBox).marginTop)||0)+'px + '+smsOffset+'px)';
    lastEmail=emailBox;
    lastSms=smsBox;
  }
  function schedule() {
    if (queued) return;
    queued=true;
    requestAnimationFrame(() => { queued=false; sync(); });
  }
  function init() {
    const footer=document.querySelector('.footer-content');
    if (!footer) return;
    if (!footerObserver) {
      footerObserver=new MutationObserver(schedule);
      footerObserver.observe(footer,{childList:true,subtree:true});
      if (typeof IntersectionObserver!=='undefined') {
        new IntersectionObserver(entries=> {
          if(entries.some(e=>e.isIntersecting)) schedule();
        },{rootMargin:'200px'}).observe(footer);
      }
    }
    schedule();
    [250,850,1800,3500].forEach(ms=>setTimeout(schedule,ms));
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  window.addEventListener('resize',schedule,{passive:true});
  document.addEventListener('shopify:section:load',init);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
})();